import * as devisConf from '@/configuration/devisConf';

export default function suppressionRegroupementPersonnalise(
  ordreLigneASupprimer, lignesCommande,
) {
  const ligneASupprimer = lignesCommande.find(l => l.ordre === ordreLigneASupprimer);
  const indexSuppression = lignesCommande.indexOf(ligneASupprimer);
  lignesCommande.forEach(ligne => {
    if (ligne.referencePersonnalise
      && ligne.referencePersonnalise === ligneASupprimer.referencePersonnalise
      && ligne.ordre !== ordreLigneASupprimer) {
      ligne.referencePersonnalise = null;
      if (ligne.type === devisConf.REGROUPEMENT) {
        ligne.lignesCommande.forEach(sousLigne => {
          sousLigne.referencePersonnalise = null;
        });
      }
    }
  });

  lignesCommande.splice(indexSuppression, 1);
}
